import React from "react";
import moment from "moment";
import styles from "../quotation.module.css";

const Field = ({ label, children }) => (
  <div>
    <dt>{label}</dt>
    <dd>{children === "Not available" ? <span className={styles.none} title="Not available">—</span> : children}</dd>
  </div>
);

export default function TopProductDetailsForm({ savedProduct, clientInfo }) {
  const storeName = savedProduct?.store?.store_name;
  const productUrl = storeName && savedProduct?.handle ? `https://${storeName}/products/${savedProduct.handle}` : "";

  return (
    <dl className={styles.overview}>
      <Field label="Quotation for">{storeName || "Not available"}</Field>
      <Field label="Product URL">
        {productUrl ? (
          <a href={productUrl} target="_blank" rel="noreferrer" title={productUrl}>
            {productUrl.replace("https://", "")}
          </a>
        ) : (
          "Not available"
        )}
      </Field>
      <Field label="Shopify product ID">{savedProduct?.shopify_product_id || "Not available"}</Field>
      <Field label="Client name">{clientInfo?.clientName || "Not available"}</Field>
      <Field label="Client since">
        {clientInfo?.clientSince ? moment(clientInfo.clientSince).format("LL") : "Not available"}
      </Field>
      <Field label="Open orders">{clientInfo?.totalOrdersByProduct || 0}</Field>
      <Field label="Total orders">{clientInfo?.totalOrders || 0}</Field>
    </dl>
  );
}
